export const icon = (type, image) => {
  return {
    type: "symbol",
    images: [type, image, { sdf: true }],
    layout: {
      "icon-image": type,
      "icon-size": 0.5,
      "icon-allow-overlap": true,
      "icon-ignore-placement": true,
      "icon-offset": [0, 0],
      "text-field": "{label}",
      "text-font": ["Open Sans Bold", "Arial Unicode MS Bold"],
      "text-size": 10,
      "text-allow-overlap": false,
      "text-ignore-placement": false,
      "text-offset": [0, -0.4],
    },
    paint: {
      "icon-color": { type: "identity", property: "color" },
      "text-color": "#fff",
    },
  };
};
